import {Model} from 'vue-mc';
import http from "../httpMiddleware/http";

Model.prototype.$http = http;
export default class bookingAvailableModel extends Model {

    // defaults() {
    //     return {
    //         id: '',
    //         ref_num: '',
    //         fm_interpreter_id: '',
    //         location_id: '',
    //         location: '',
    //         location_details: '',
    //         location_name: '',
    //         location_address_1: '',
    //         location_address_2: '',
    //         location_suburb: '',
    //         location_postcode: '',
    //         service_date: '',
    //         service_time_start: '',
    //         service_time_end: '',
    //         actual_start: '',
    //         actual_end: '',
    //         start: '',
    //         end: '',
    //         interpreter_local_start: '',
    //         interpreter_local_end: '',
    //         job_local_start: '',
    //         job_local_end: '',
    //         service_date_formatted: '',
    //         client_id: '',
    //         blackberries_sent: '',
    //         available_num: '',
    //         inter_trans: '',
    //         booking_type: '',
    //         language: '',
    //         school_number: '',
    //         Cancellation: '',
    //         onhold: '',
    //         web_def_Full_Restrict_NAATI_Lvl: '',
    //         minimum_booking_length: '',
    //         client_info: '',
    //         web_address: '',
    //         language_id: '',
    //         lang_exception_naati: '',
    //         client_restr_int: '',
    //         L1_int_NAATI: '',
    //         booking_made_by_client: '',
    //         home_visit: '',
    //         client_state: '',
    //         state: '',
    //         bb_send: '',
    //         bb_sent: '',
    //         gender_check: ''
    //     }
    // }
    defaults() {
        return {
          location: "",
          location_id: "",
          ref_num: "",
          service_date: "",
          service_time_start: "",
          service_time_end: "",
          actual_start: "",
          actual_end: "",
          client_id: "",
          blackberries_sent: "",
          available_num: "",
          inter_trans: "",
          booking_type: "",
          language: "",
          fm_interpreter_id: "",
          Cancellation: "",
          onhold: "",
          booking_made_by_client: "",
          home_visit: "",
          service_date_formatted: "",
          interpreter_id: "",
          location_name: "",
          location_details: "",
          clinic_ward: "",
          location_address_1: "",
          location_address_2: "",
          location_suburb: "",
          location_postcode: "",
          web_def_Full_Restrict_NAATI_Lvl: "",
          minimum_booking_length: "",
          client_info: "",
          web_address: "",
          client_state: "",
          language_id: "",
          lang_exception_naati: "",
          client_restr_int: "",
          job_restr_int: "",
          locationClientStateId: "",
          locationClientCountryId: "",
          start: "",
          end: "",
          gender_check: "",
          isDoubleBooking: "",
          job_documents_required: "",
          interpreter_docs_received: ""
        }
    }

    routes() {
        return {}
    }
}
